import { VictoryContainer, VictoryPie } from 'victory';
import * as React from 'react';

import { pieChartColors } from '../../config';
import { SurveyResultQuestion } from '../../types';
import useMq from '../../hooks/useMq';

import Text from '../../../../text/Text.jsx';

export type SurveyResultProps = {
  headline?: React.ReactNode;
  questionResults: SurveyResultQuestion;
};

const NullPieSlice = () => null;

const SurveyResult = ({ headline, questionResults }: SurveyResultProps) => {
  const chartData = React.useMemo(
    () =>
      questionResults.results
        .filter((r) => r.count > 0) // remove zero response answers
        .map((r, i) => ({
          x: r.answer.label,
          y: r.count,
          percent: r.percent,
          fg: pieChartColors[i % pieChartColors.length][0]
        })),
    [questionResults]
  );

  const isDesktop = useMq('(min-width: 960px)');

  const typoCopySmall = {
    fontSize: isDesktop ? '14px' : '12px',
    fontWeight: 500,
    fontFamily: 'Roboto, sans-serif',
    fill: '#4a4a4a'
  };

  const width = isDesktop ? 450 : 375;

  const height = 300;

  return (
    <div className="survey-result">
      {headline && (
        <Text className="survey-result__headline" variant="copy-bold" tag="h4">
          {headline}
        </Text>
      )}

      <VictoryContainer
        width={width}
        height={height}
        style={{
          aspectRatio: `${width} / ${height}`,
          maxWidth: width,
          margin: 'auto'
        }}
      >
        {/* pie chart with percentage labels on the slices */}
        <VictoryPie
          standalone={false}
          data={chartData}
          colorScale={pieChartColors.map(([, g]) => g)}
          innerRadius={50}
          padAngle={2}
          height={height}
          width={width}
          labelRadius={65}
          labels={({ datum }) => `${datum.percent}%`}
          style={{
            labels: {
              ...typoCopySmall,
              fill: ({ datum }: any) => datum.fg
            }
          }}
        />

        {/* outer labels only */}
        <VictoryPie
          standalone={false}
          data={chartData}
          height={height}
          width={width}
          labels={({ datum }) => datum.x.split('\u00AD')}
          dataComponent={<NullPieSlice />}
          style={{
            labels: {
              ...typoCopySmall
            }
          }}
        />
      </VictoryContainer>
    </div>
  );
};

export default SurveyResult;
